import { Component } from '@angular/core';
import { ButtonComponent, IconComponent } from '@ird/ng-base';
import { PermissionOverlayService } from '../../services';

@Component({
  selector: 'shared-overlay-button',
  templateUrl: './overlay-button.component.html',
  styleUrls: ['overlay-button.component.scss'],
  imports: [ButtonComponent, IconComponent],
})
export class OverlayButtonComponent {
  constructor(private permissionOverlayService: PermissionOverlayService) {}

  public toggleOverlay(): void {
    this.permissionOverlayService.toggle();
  }
}
